module.exports = __webpack_public_path__ + "media/assets/svg/logos/leanbit_logo_symbol_rounded-a141b06671817c841ca34721a95955db.svg";